const SYS_TITLE = '顾客增长引擎';
const KeywordList = [SYS_TITLE, '米雅科技'];
const COPYRIGHT = 'Copyright © 2018  杭州米雅信息科技有限公司 版权所有 浙ICP备15014474号';
const ICONFONT_CSS_URL = '//at.alicdn.com/t/font_1755643_kqjdgp78rn.css';
const ICONFONT_SCRIPT_URL = '//at.alicdn.com/t/font_1755643_kqjdgp78rn.js';

module.exports = {
  SYS_TITLE,
  KeywordList,
  COPYRIGHT,
  ICONFONT_CSS_URL,
  ICONFONT_SCRIPT_URL,
};
